import { STANDARD_DATA_SUCCESS, STANDARD_DATA_ERROR } from '../constants/actionTypes';
  
  const INITIAL_STATE = { data: null, error: null };
  
  export default function standardDataReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
      case STANDARD_DATA_SUCCESS:
       
        return {
          data: action.payload.data,
          error: null
        };
      case STANDARD_DATA_ERROR:
        return {
          
          data: [],
          error: action.payload.message
        };
      default:
        return state;
    }
  }
  